var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"outreach-tag-segments"},[_c('list-tag',{attrs:{"tags":_vm.tagsData,"type":_vm.OUT_REACH_TAG_TYPE.TAG}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }